import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const STAGES = [
  {
    label: "Today",
    tone: "border-white/10 bg-white/[0.03]",
    items: [
      "Level 1 development plan in place",
      "Core product scope defined",
      "SEIS Advance Assurance application in preparation — subject to HMRC approval",
      "Concept demonstrations published",
    ],
  },
  {
    label: "In Development",
    tone: "border-cyan-300/25 bg-cyan-300/[0.05]",
    items: [
      "Level 1 — the current commercial build",
      "Photorealistic AI character with real-time video",
      "Natural voice and conversational AI",
      "Facial reactions and movement",
      "Signup, demo, subscription and payments",
      "Beta analytics, moderation and feedback",
    ],
  },
  {
    label: "Next",
    tone: "border-white/10 bg-white/[0.03]",
    items: [
      "Closed beta with targeted early users",
      "Validate conversion from early access to paid usage",
      "Measure retention, paid usage and willingness to pay",
      "Scale acquisition only once unit economics are measurable",
    ],
  },
];

export default function Status() {
  return (
    <section data-testid="status-section" className="relative bg-[#0a0a0a] py-16 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <SectionTag>Project Status</SectionTag>
          <h2 className="font-display mt-5 max-w-2xl text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
            Where the Project <span className="text-cyan-300">Stands</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#C5CBD5]">
            An honest snapshot: what exists today, what is being built right now, and what comes
            next once Level 1 is validated.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:items-stretch">
          {STAGES.map(({ label, tone, items }, i) => (
            <Reveal key={label} delay={0.08 * i} className="contents">
              <div
                data-testid={`status-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`rounded-2xl border p-7 ${tone}`}
              >
                <p className="font-display text-[11px] font-semibold uppercase tracking-[0.3em] text-cyan-300/90">
                  {label}
                </p>
                <ul className="mt-5 space-y-3">
                  {items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-[#C5CBD5]">
                      <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-cyan-300/70" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              {i < STAGES.length - 1 && (
                <div aria-hidden="true" className="flex items-center justify-center py-1 lg:py-0">
                  <ArrowRight size={16} className="rotate-90 text-cyan-300/40 lg:rotate-0" />
                </div>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
